export const LOCALE_COOKIE_KEY = 'locale';
export const TOKEN_COOKIE_KEY = 'token';
